
    var riot = require('riot')
    //src: starling/src/tags/attributes-tab.html
riot.tag2('attributes-tab',
  '<aside ref="main" class="side-tab"> <header class="side-tab_header"> <span class="side-tab_header_logo"> <i class="side-tab_header_icon fa fa-tags"></i> </span> <h3 class="side-tab_header_title">Tags</h3> <i class="side-tab_header_help side-tab_header_icon material-icons" onclick="{openAttributesHelp}">help</i> </header> <div ref="scrollList" class="side-tab_body" onwheel="{handleScroll}"> <div if="{!getAttributes().length}" class="side-tab_body_empty"> <p class="side-tab_body_empty_message">Use tags to add filterable categories and details to your cards.</p> <p class="side-tab_body_empty_message">Add tags to cards by visiting the card\'s menu or right clicking on a card.</p> </div> <ul ref="attributeList" class="attribute-list "> <li each="{getAttributes()}" class="attribute-list_item attribute-list_item--{parent.isExpanded(name) ? \'expanded\' : \'collapsed\'}" data-key="{name}" onclick="{() => this.toggleValuesList(name)}"> <span class="side-tab_item attribute-list_key"> <svg class="side-tab_item_icon attribute-list_key_icon"> <use xlink:href="#keyboard-arrow-down-icon"></use> </svg> <span class="side-tab_item_label">{name}</span> </span> <ul ref="attributeValuesList" class="attribute-list_values"> <li each="{value in getAttributeValues(name)}" class="side-tab_item side-tab_item--iconless attribute-list_value {parent.parent.highlighted === `${this.name}:${this.value}` ? \'active\' : \'\'}" data-attr-name="{name}" data-attr-value="{value}" data-key="{name}:{value}" onclick="{parent.parent.toggleValueFilter.bind(this, name, value)}"> <span class="side-tab_item_label">{value}</span> </li> </ul> </li> </ul> </div> <footer class="side-tab_footer"> </footer> </aside> <div ref="menu" class="floating-menu floating-menu--hidden floating-menu--fixed"> <ul class="floating-menu_list"> <li class="floating-menu_item" onclick="{removeAttribute}"> <i class="material-icons floating-menu_icon">delete</i> <span class="floating-menu_label">Delete</span> </li> </ul> </div>',
  '',
  'class="side-tab_container"', function(opts) {
'use strict';

var _this = this;

var _sortablejs = require('sortablejs');

var _sortablejs2 = _interopRequireDefault(_sortablejs);

var _store_instance = require('../store_instance');

var _store_instance2 = _interopRequireDefault(_store_instance);

var _nodesUi = require('lib/nodes-ui');

var _bulkAttributesUi = require('lib/bulk-attributes-ui');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var expandedAttributes = new Set();
var _opts = opts,
    canvas = _opts.canvas;

canvas.attributesTabTag = this;

this.isOpen = false;
this.hasOpened = false;

this.on('mount', function () {
  var attributeList = _this.refs.attributeList;

  if (canvas.isViewOnly()) return;

  _this.initSortable(attributeList);
  _this.initAtributeValuesListSortable();
});

this.on('updated', function () {
  _this.initAtributeValuesListSortable();
});

this.initAtributeValuesListSortable = function () {
  var attributeValuesList = _this.refs.attributeValuesList;

  if (canvas.isViewOnly()) return;

  if (attributeValuesList) {
    if (Array.isArray(attributeValuesList)) {
      attributeValuesList.forEach(_this.initSortable);
    } else {
      _this.initSortable(attributeValuesList);
    }
  }
};

this.initSortable = function (list) {
  // new Sortable(list, {
  //   animation: 150,
  //   ghostClass: 'attribute-list--dropzone',
  //   dragClass: 'attribute-list--dragging',
  //   onStart: (e) => {
  //     list.classList.add('attribute-list--sorting');
  //     const name = e.item.getAttribute('data-attr-name');
  //     const value = e.item.getAttribute('data-attr-value');
  //     this.draggingAttribute = { name, value };
  //   },
  //   onEnd: () => {
  //     list.classList.remove('attribute-list--sorting');
  //     this.draggingAttribute = null;
  //   },
  // });
};

this.getAttributes = function () {
  var attributes = _store_instance2.default.getAttributeFilterObj();

  return Object.keys(attributes).sort(function (a, b) {
    if (a === '#') return 1;
    if (b === '#') return -1;
    return attributes[b].count - attributes[a].count;
  }).map(function (attr) {
    return { name: attr };
  });
};

this.getAttributeValues = function (name) {
  var attributes = _store_instance2.default.getAttributeFilterObj();

  return Object.keys(attributes[name].values).sort(function (a, b) {
    return attributes[name].values[b].count - attributes[name].values[a].count;
  });
};

this.setActive = function (key) {
  _this.clearActive();
  var el = _this.refs.attributeList.querySelector('[data-key="' + key + '"]');
  if (el) {
    el.classList.add('active');
  }
};

this.clearActive = function () {
  for (var _iterator = _this.refs.attributeList.querySelectorAll('[data-key]'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var el = _ref;

    if (el.classList.contains('active')) {
      el.classList.remove('active');
    }
  }
};

this.hasActiveAttribute = function () {
  return Boolean(_this.highlighted);
};

this.toggleOff = function () {
  _this.highlighted = false;
  _this.clearActive();
  _this.unhighlightNodes();
  _eventTracking2.default.track({
    category: 'Attributes',
    action: 'Attr-Value-Filter-Off',
    label: 'Attr-Tab-Toggle-Filter'
  });
};

this.toggleNameFilter = function (name, e) {
  e.stopPropagation();
  if (_this.highlighted === name) {
    _this.toggleOff();
    return;
  }
  var nodes = _store_instance2.default.getNodesArray().filter(function (n) {
    return n.attributes.card && n.attributes.card.find(function (a) {
      return a.name === name && a.value === value;
    });
  });
  _this.highlightNodes(nodes);
  _this.highlighted = name;
  _this.setActive(_this.highlighted);
};

this.toggleValueFilter = function (name, value, e) {
  e.stopPropagation();

  if (_this.highlighted === name + ':' + value) {
    _this.highlighted = false;
    _this.clearActive();
    _this.unhighlightNodes();
    _eventTracking2.default.track({
      category: 'Attributes',
      action: 'Attr-Tab-Value-Filter-Off',
      label: 'Attr-Tab-Toggle-Filter'
    });
    return;
  }
  var nodes = _store_instance2.default.getNodesArray().filter(function (n) {
    return n.getAttributes() && n.getAttributes().find(function (a) {
      return a.name === name && a.value === value;
    });
  });
  _this.highlightNodes(nodes);
  _this.highlighted = name + ':' + value;
  _this.setActive(_this.highlighted);
  _eventTracking2.default.track({
    category: 'Attributes',
    action: 'Attr-Tab-Value-Filter-On',
    label: 'Attr-Tab-Toggle-Filter'
  });
};

this.handleScroll = function (event) {
  return event.stopPropagation();
};

this.highlightNodes = function (nodes) {
  _this.unhighlightNodes();
  var color = '#8595a9';
  canvas.refs.canvas.style.setProperty('--card-border-highlight-color', color);
  document.body.classList.add('user-presence-active');

  for (var _iterator2 = nodes, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref2;

    if (_isArray2) {
      if (_i2 >= _iterator2.length) break;
      _ref2 = _iterator2[_i2++];
    } else {
      _i2 = _iterator2.next();
      if (_i2.done) break;
      _ref2 = _i2.value;
    }

    var node = _ref2;

    var nodeTag = canvas.nodeTags[node.id];
    if (nodeTag) {
      nodeTag.setPresenceHovered();
      _nodesUi.nui.highlightCardBorders(nodeTag.instance);
    }
  }
};

this.unhighlightNodes = function (e) {
  $('.user-presence-highlight').removeClass('user-presence-highlight');
  $('.parent-of-user-presence-highlight').removeClass('parent-of-user-presence-highlight');
  _nodesUi.nui.unhighlightAllCardBorders();
  canvas.refs.canvas.style.removeProperty('--card-border-highlight-color');
  document.body.classList.remove('user-presence-active');
};

this.stopPropagation = function (e) {
  e.stopPropagation();
  e.preventDefault();
};

this.isExpanded = function (key) {
  return expandedAttributes.has(key);
};

this.collapseValuesList = function (key) {
  expandedAttributes.delete(key);
  _this.update();
};

this.expandValuesList = function (key) {
  expandedAttributes.add(key);
  _this.update();
};

this.toggleValuesList = function (key) {
  if (_this.isExpanded(key)) {
    _this.collapseValuesList(key);
    _eventTracking2.default.track({
      category: 'Attributes',
      action: 'Attr-Tab-Collapse-Values',
      label: 'Attr-Tab-Toggle-Values'
    });
  } else {
    _this.expandValuesList(key);
    _eventTracking2.default.track({
      category: 'Attributes',
      action: 'Attr-Tab-Expand-Values',
      label: 'Attr-Tab-Toggle-Values'
    });
  }
};

this.openAttributesHelp = function (event) {
  event.stopPropagation();
  canvas.openSidebar('user-guide');
  canvas.userGuideTag.openItem('about-attributes');
};

this.summonMenu = function (e) {
  var currentTarget = e.currentTarget;

  var container = $(currentTarget).closest('li').get(0);
  var key = container.getAttribute('data-key');

  var _container$getBoundin = container.getBoundingClientRect(),
      right = _container$getBoundin.right,
      top = _container$getBoundin.top;

  var menu = _this.refs.menu;

  e.stopPropagation();

  if (_this.menuShowing && _this.activeMenuAttribute === key) {
    _this.hideMenu();
    return;
  }

  Object.assign(menu.style, {
    left: right + 'px',
    top: top + 'px'
  });

  _this.menuShowing = true;
  _this.activeMenuAttribute = key;
  menu.classList.remove('floating-menu--hidden');
};

this.hideMenu = function () {
  var menu = _this.refs.menu;

  if (_this.menuShowing) {
    _this.menuShowing = false;
    _this.activeMenuAttribute = null;
    menu.removeAttribute('style');
    menu.classList.add('floating-menu--hidden');
  }
};

this.removeAttribute = function () {
  var activeMenuAttribute = _this.activeMenuAttribute;

  var _activeMenuAttribute$ = activeMenuAttribute.split(':'),
      key = _activeMenuAttribute$[0],
      value = _activeMenuAttribute$[1];

  if (key && !value) {
    _bulkAttributesUi.baui.removeAttributesByName({ name: key });
  } else if (key && value) {
    _bulkAttributesUi.baui.removeAttributesByValue({ name: key, value: value });
  }

  _this.hideMenu();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('attributes-tab')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/attributes-tab.html
// module id = 743
// module chunks = 0